module.exports = __webpack_public_path__ + "static/icons/icon-print-4f5ca9fc094853424724ab544b39102e.svg";